document.getElementById("gdc-geo-selector").addEventListener("click", geoPop);
document.querySelector(".gdc-geo-pop .popup-close").addEventListener("click", geoPopHide);
document.querySelector("#geo-popup-proceed button.button").addEventListener("click", goToShop);

document.addEventListener('keydown', e=>{
    if ( e.keyCode == 27 ) {
        if ( document.getElementById("gdc-geo-switcher-popup").classList.contains('active') ) {
            document.getElementById("gdc-geo-switcher-popup").classList.remove('active');
            document.getElementById("gdc-geo-switcher-popup").style.display = 'none';
            document.querySelector(".site-overlay").style.display = 'none';
            document.querySelector(".site-overlay").style.opacity = '0';
            document.querySelector(".site-overlay").style.visibility = 'hidden';
        }
    }
});

function geoPop() {
   if ( document.getElementById("gdc-geo-switcher-popup").classList.contains('active') ) {
     geoPopHide();
   } else {
     geoPopShow();
   }
}

function geoPopShow() {
  document.getElementById("gdc-geo-switcher-popup").style.display = 'block';
  document.getElementById("gdc-geo-switcher-popup").classList.add('active');
  document.querySelector(".site-overlay").style.display = 'block';
  document.querySelector(".site-overlay").style.opacity = '100';
  document.querySelector(".site-overlay").style.visibility = 'visible';
}

function geoPopHide() {
  document.getElementById("gdc-geo-switcher-popup").classList.remove('active');
  document.getElementById("gdc-geo-switcher-popup").style.display = 'none';
  document.querySelector(".site-overlay").style.display = 'none';
  document.querySelector(".site-overlay").style.opacity = '0';
  document.querySelector(".site-overlay").style.visibility = 'hidden';
}

function goToShop() {
  var shopLoc = document.getElementById("shop-location").value;
  if (document.getElementById("shop-lang") != null) {
    var shopLang = document.getElementById("shop-lang").value;
    window.location.href = shopLoc + shopLang;
  } else {
    window.location.href = shopLoc;
  }
}